<template>
	<div id="app" class="pageBody" :style="{'min-height':screenHeight+'px'}">
		<div class="loadBox" @click="floodingBtn"></div>
		<el-container style="height: 100%;">
			<!-- :default-openeds="openeds" -->
			<div id="zfyLogoBox" >
				<a href="https://www.zhongfuyun.com/" target ="_blank">
					<img class="" src="./assets/img/logo.png" alt="">
					<p v-show="logoNameShow" class="logo-name ">灵活用工服务平台</p>
				</a>
			</div>
			<el-aside class="aside_box"  id="aside_box" :style="{'min-height':screenHeight +'px'}" :width="scalingBoolean?'65px':'200px' ">
				<el-menu router :unique-opened='true' :default-active="routerNow" class="el-menu-vertical-demo" :style="{'min-height':screenHeight-2+'px'}" :collapse="scalingBoolean">
					<div class="sidebar-brand"></div>
					<div class="navSubtitle " v-if="logoNameShow">常用操作</div>
					<el-menu-item :class="scalingBoolean?'Nav_item0':'Nav_item1'" index="/dataExpress">
						<i class="font-20 zb zb-home"></i>
						<span slot="title">首页</span>
					</el-menu-item>
					<!-- <el-menu-item :class="scalingBoolean?'Nav_item0':'Nav_item1'" index="/projectNew">
						<i class="font-20 zb zb-xinjian"></i>
						<span slot="title">批量新建订单</span>
					</el-menu-item>
					<el-menu-item :class="scalingBoolean?'Nav_item0':'Nav_item1'" index="/fundRecharge">
						<i class="font-20 zb zb-chongzhi"></i>
						<span slot="title">专属账户</span>
					</el-menu-item> -->
					
					<div class="navSubtitle m-t-10 " v-if="logoNameShow">业务管理</div>
					<el-submenu index="1" class="menuListBox" :class="scalingBoolean?'Nav_item0':'Nav_item1'">
						<template slot="title">
							<i class="font-20 zb zb-orderManage"></i>
							<span slot="title">项目任务</span>
						</template>
						<el-menu-item index="/projectNew">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">批量新建订单</span>
						</el-menu-item>
						<el-menu-item index="/projectManage">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">项目列表</span>
						</el-menu-item>
						<el-menu-item index="/orderTask">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">任务派单</span>
						</el-menu-item>
						<el-menu-item index="/orderList">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">订单列表</span>
						</el-menu-item>
						<!-- <el-menu-item index="/orderAbnormal">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">异常订单</span>
						</el-menu-item> -->
						<!-- <el-menu-item index="/projectAbandon">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">作废项目</span>
						</el-menu-item> -->
					</el-submenu>
					<el-submenu index="2" class="menuListBox" :class="scalingBoolean?'Nav_item0':'Nav_item1'">
						<template slot="title">
							<i class="font-20 zb zb-fapiao" style="font-size: 16px;"></i>
							<span slot="title">资金发票</span>
						</template>
						<el-menu-item index="/fundRecharge">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">专属账户</span>
						</el-menu-item>
						<el-menu-item index="/fundInfo">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">账户余额</span>
						</el-menu-item>
						<el-menu-item index="/invoiceList">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">发票申请记录</span>
						</el-menu-item>
						<el-menu-item index="/invoiceAddr">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">发票收件地址</span>
						</el-menu-item>
					</el-submenu>
					<el-submenu index="3" class="menuListBox" :class="scalingBoolean?'Nav_item0':'Nav_item1'">
						<template slot="title">
							<i class="font-20 zb zb-enterprise"></i>
							<span slot="title">企业管理</span>
						</template>
						<!-- <el-menu-item index="/personInfo">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">人员认证签约</span>
						</el-menu-item> -->
						<el-menu-item index="/companyInfo">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">企业信息资料</span>
						</el-menu-item>
						<!-- <el-menu-item index="/identityCompanyLCE">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">签约费率&amp;结算通道</span>
						</el-menu-item> -->
						<!-- <el-menu-item index="/personnelSigning">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">人员认证签约</span>
						</el-menu-item> -->
						<!-- <el-menu-item index="/personMaintain">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">人员维护</span>
						</el-menu-item> -->
					</el-submenu>
					
					<!-- <el-submenu index="5" class="menuListBox" :class="scalingBoolean?'Nav_item0':'Nav_item1'">
						<template slot="title">
							<i class="font-20 zb zb-u97"></i>
							<span slot="title">灵活用工</span>
						</template>
						<el-menu-item index="/lhygCompanyInfo">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">企业介绍</span>
						</el-menu-item>
						<el-menu-item index="/lhygCompanyAddr">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">用工地址</span>
						</el-menu-item>
						
					</el-submenu> -->
					
					<!-- <el-submenu index="6" class="menuListBox" :class="scalingBoolean?'Nav_item0':'Nav_item1'">
						<template slot="title">
							<i class="font-20 zb zb-hetongguanli"></i>
							<span slot="title">合同管理</span>
						</template>
						<el-menu-item index="/签约状态">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">签约状态</span>
						</el-menu-item>
						<el-menu-item index="/合同内容">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">合同内容</span>
						</el-menu-item>
					</el-submenu> -->
					<!-- <el-submenu index="7" class="menuListBox" :class="scalingBoolean?'Nav_item0':'Nav_item1'">
						<template slot="title">
							<i class="font-20 zb zb-zhuanshukefu"></i>
							<span slot="title">专属客服</span>
						</template>
						<el-menu-item index="/联系方式">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">联系方式</span>
						</el-menu-item>
						<el-menu-item index="/问题反馈">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">问题反馈</span>
						</el-menu-item>
					</el-submenu> -->
					<div class="navSubtitle m-t-10 " v-if="logoNameShow">服务中心</div>
					<el-submenu index="8" class="menuListBox" :class="scalingBoolean?'Nav_item0':'Nav_item1'">
						<template slot="title">
							<i class="font-20 zb zb-shenfenyanzheng-"></i>
							<span slot="title">身份&amp;安全</span>
						</template>
						<!-- <el-menu-item index="/operatingRecord">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">历史操作记录</span>
						</el-menu-item> -->
						<el-menu-item index="/userPassword">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">账号密码</span>
						</el-menu-item>
						<!-- <el-menu-item index="/安全设置">
							<i class="zb zb-greaterThan movejiantou" ></i>
							<span class="lowerMenu">安全设置</span>
						</el-menu-item> -->
					</el-submenu>

				</el-menu>
			</el-aside>
			<el-container class="header_box">
				<!-- 头部区域 -->
				<el-header id="el_header" height='50px'>
					<div class="fl" v-if="colLeftBox">
						<span @click="switchover" id="hideTrigger"></span>
						<!-- <i class="zfy zfy-fold pointer switchBtnPc "  style="font-size: 20px;" @click="trigge"></i> -->
						<i class="zb zb-fold pointer switchBtnPc font-20" @click="trigge"></i>
						<i class="zb zb-fold pointer switchBtnWebApp font-20" @click="switchover1"></i>
						<i class="zb zb-fullScreen padding-10 pointer font-20" @click="screenMpBtn"></i>
						<!-- <div class="header_search">
							<el-input id="search_ipt" size="medium" placeholder="请输入关键字搜索"></el-input>
							<i class="zb zb-search" id="search_but" @click='searchBtn()'></i>
						</div> -->
					</div>
					<div class="fr headerLeftArea">
						<div class="companyName pointer animated bounceInLeft">
							<a target ="_blank">{{userInfo.enterprise_name}}</a>
						</div>
						<!-- <a href="#" style="color: #FFFFFF;display: inline-block;margin:0 10px;padding:0 5px;text-align: center;">
							<i class="zb zb-envelope font-20"></i>
						</a>
						<a href="#" style="color: #FFFFFF;display: inline-block;argin:0 10px;padding:0 5px;text-align: center;">
							<i class="zb zb-inform  font-20"></i>
						</a> -->
						<el-popover placement="bottom" width="" trigger="click" class="exitBox">
							<!-- <div class="exitBox-title">{{userInfo.username}}</div> -->
							<ul class="undeOne ">
								<li @click="goToUserPassword">
									<i class="zb zb-authentication" style="font-size: 12px;margin-right: 10px;"></i>
									账号密码
								</li>
								<!-- <li>
									<i class="zb zb-anquanshezhi" style="font-size: 12px;margin-right: 10px;"></i>
									安全设置
								</li> -->
								<li class="exitAccountBox" @click="exitAccount"> 
									<i class="zb zb-icon-" style="font-size: 14px;margin-right: 10px;"></i>
									退出登录
								</li>
							</ul>
							<el-button style="background: none; border:none;color: #FFFFFF;" slot="reference">
								<span style="margin-left: 10px;" class="el-icon-setting  font-20"></span>
							</el-button>
						</el-popover>
					</div>
				</el-header>
				<!-- 内容区域 -->
				<el-main :style="{'min-height': screenHeight+'px'}" :class="scalingBoolean?'thinNav':'fatNav' " style='overflow-x: hidden;'>
					<router-view></router-view>
					<!-- <footer class="main-footer clear">
					  <div class="fl" style="color: #98a6ad;font-size: 10px;font-weight: 600;">
					    Copyright &copy; 2020 <a href="https://www.zhongfuyun.com/" target ="_blank" class="footerHref">中服云</a>（北京）科技有限公司
					  </div>
					  <div class="fr" style="color: #98a6ad;font-size: 10px;font-weight: 600;">
					  	电话：400-820-0088
					  </div>
					</footer> -->
				</el-main>
			</el-container>
		</el-container>
		<el-tooltip class="item" effect="dark" content="回到顶部" placement="top">
			<i class="zb zb-upward returnTop "@click="returnBtn"></i>
		</el-tooltip>
	</div>
</template>

<script>
	import {
		common
	} from '../static/tool.js';
	import {
		mainfun
	} from './assets/js/main.js';
	import screenfull from 'screenfull';
	export default {
		name: 'App',
		data() {
			return {
				url: common.url, //请求前缀
				userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
				openLoading: common.openLoading, //遮罩开启
				userName: sessionStorage.getItem('userName'),
				routerNow: '', //当前路由
				screenWidth: document.documentElement.clientWidth,
				screenHeight: document.documentElement.clientHeight,
				windowSizeHeight :document.documentElement.clientHeight,//浏览器可视化窗口的大小
				manageUser: '', //登录账户信息
				isNavLeft: true,  //全局变量 菜单栏放大缩小
				scalingBoolean: false, //菜单样式，true精简 false详细
				logoNameShow: true, //logo名字
				colLeftBox: true,  //头部搜索区域 显示/隐藏
				fullscreen: false, //是否全屏
				openeds:['1','2','3','4','8'],
				typeWidthshow:false, //模拟点击事件
			}
		},
		mounted() {
			this.setrouterNow(); //当前菜单高亮
			this.startResult();
			this.mouseOver(); //鼠标移入  箭头移动
			this.mouseLeave(); //鼠标移出  箭头回位
			this.screenHeight = `${document.documentElement.clientHeight}`;
			this.screenWidth = `${document.documentElement.clientWidth}`;
			window.onresize = () => {
				this.screenHeight = document.documentElement.clientHeight;
				this.screenWidth = document.documentElement.clientWidth;
				
				if (this.screenWidth <= 992) {
					this.logoNameShow = true;
					this.scalingBoolean = false;
					common.closeLoading();
					$('#el_header').removeClass("p-l-70i");
				}
			};
			
		},
		methods: {
			startResult() {
				if(!sessionStorage.getItem('userInfo')){
					window.location = 'login.html';
					return;
				}
				/* 鼠标聚焦时，回车事件 */
				$("#search_ipt").bind("keypress", function() {
					if (event.keyCode == 13) {
						// 触发需要调用的方法
						$("#search_but").click();
					}
				})
				$(window).scroll(() => {
					let yheight1 = window.pageYOffset; //滚动条距顶端的距离  
					if (yheight1 > 400) {
						$('.returnTop').css({'display':'block'});
					} else {
						$('.returnTop').css({'display':'none'});
					}
				})
			},
			returnBtn(){ //回到顶部
				$('html,body').animate({scrollTop:0},300);
			},
			// 移入
			mouseOver() {
				var alowerMenu = document.getElementsByClassName('lowerMenu');
				var aMoveJt = document.getElementsByClassName('movejiantou');
				for (let i = 0; i < alowerMenu.length; i++) {
					alowerMenu[i].onmouseenter = () => {
						aMoveJt[i].style.left = 35 + 'px';
						aMoveJt[i].style.color = '#000000';
					}
				}
			},
			// 移出
			mouseLeave() {
				var alowerMenu = document.getElementsByClassName('lowerMenu');
				var aMoveJt = document.getElementsByClassName('movejiantou');
				for (let i = 0; i < alowerMenu.length; i++) {
					alowerMenu[i].onmouseleave = () => {
						aMoveJt[i].style.left = 30 + 'px';
						aMoveJt[i].style.color = '#909399';
					}
				}
			},
			searchBtn() { //顶部搜索事件
				console.log('s');
			},
			switchover() { //大于992切换
				this.scalingBoolean = !this.scalingBoolean;
				if (this.scalingBoolean) {
					$('#el_header').addClass("p-l-70i");
					$('#el_header').removeClass("p-l-260");
				} else {
					$('#el_header').addClass("p-l-260");
					$('#el_header').removeClass("p-l-70i");
				}
			},
			// 模拟点击触发菜单栏  模式切换
			trigge(){
				this.typeWidthshow = !this.typeWidthshow;
				if(this.typeWidthshow){
					$('#zfyLogoBox').css({width:'65px'})
					setTimeout(()=>{
						$('#zfyLogoBox a').css({marginLeft:'15px'})
					},350)
					this.logoNameShow = false;
				}else{
					$('#zfyLogoBox').css({width:'200px'})
					setTimeout(()=>{
						$('#zfyLogoBox a').css({marginLeft:'20px'})
						this.logoNameShow = true;
					},350)
				}
				setTimeout(()=>{
					$('#hideTrigger').trigger("click");
				},10);
				
			},
			switchover1() { //小于992切换
				// event.stopPropagation();
				if (this.isNavLeft) {
					$('#aside_box').css({
						"position": "absolute",
						"left": '0',
						"top": '0',
					});
					this.isNavLeft = !this.isNavLeft;
					common.openLoading();  //打开遮罩层
					this.colLeftBox = false;
					mainfun.scrollTop(); //回到页面顶端
					$('.el-main').css({"position": "fixed","overflow": 'hidden',})
				}
			},
			floodingBtn() { //全屏遮罩点击
				if (this.screenWidth <= 992 && this.isNavLeft == false) {
					common.closeLoading();
					$('#aside_box').css({
						"position": "absolute",
						"left": "-200px",
						"top": "0",
					});
					$('#el_header').addClass("p-l-10");
					this.isNavLeft = !this.isNavLeft;
					setTimeout(() => {
						this.colLeftBox = true;
					}, 500);
					$('.el-main').css({"position": "relative","overflow": 'auto',})
				}
			},

			exitAccount() { //退出账号
				this.$confirm('您确定退出账号吗?', '提示', {
					cancelButtonText: '取消',
					confirmButtonText: '确定',
					type: 'warning'
				}).then(() => {
					sessionStorage.clear();
					window.location.href = 'login.html';
				}).catch(() => {

				});

			},
			goToUserPassword(){ //账号密码
				this.$router.push('/userPassword');
			},
			setrouterNow() { //当前菜单高亮	
				this.routerNow = this.$route.path;
				this.floodingBtn();
			},
			screenMpBtn() {
				let element = document.documentElement;
				if (this.fullscreen) {
					if (document.exitFullscreen) {
						document.exitFullscreen();
					} else if (document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen();
					} else if (document.mozCancelFullScreen) {
						document.mozCancelFullScreen();
					} else if (document.msExitFullscreen) {
						document.msExitFullscreen();
					}
				} else {
					if (element.requestFullscreen) {
						element.requestFullscreen();
					} else if (element.webkitRequestFullScreen) {
						element.webkitRequestFullScreen();
					} else if (element.mozRequestFullScreen) {
						element.mozRequestFullScreen();
					} else if (element.msRequestFullscreen) {
						// IE11
						element.msRequestFullscreen();
					}
				}
				this.fullscreen = !this.fullscreen;
			},

		},
		watch: {
			'$route': 'setrouterNow',
		},
	}
</script>

<style>
	/* 通用样式 */
	@import './assets/css/generalStyle.css';
	@import './assets/css/theme.css';
	@import './assets/css/styleonce.css';
	
	body {
		background: #F5F5F5;
		color: #000000;
	}
	.FundInfo,
	.FundRecharge,
	.companyInfo ,
	.IdentityCompanyLCE,
	.dataExpress , 
	.identityOperatingRecord,
	.IdentityUserPassword,
	.InvoiceAddr,
	.InvoiceDetails,
	.InvoiceList,
	.OrderAbnormal,
	.orderDetails,
	.orderList,
	.PersonMaintain,
	.IdentityCompanyInfo,
	.projectManage,
	.projectNew,
	.ProjectNewDetail,
	.projectAbandon,
	.orderTask,
	.lhygCompanyAddr,
	.lhygCompanyInfo,
	.FundInfoDetail
	{
		padding: 10px 10px 5px 10px;
	}
	
	/* app主页面Logo */
	#zfyLogoBox{position: fixed;left: 0;top: 0;z-index: 555;width: 200px;height: 50px;background-color: var(--zfy-red);transition:width 0.35s;-webkit-transition:width 0.35s; }
	#zfyLogoBox a {margin-left: 20px;text-decoration: none;text-transform: uppercase;font-weight: 500;font-size: 18px;vertical-align: bottom;color: #000;padding-top: 7px;display: inline-block;}
	#zfyLogoBox img {height: 30px;vertical-align: bottom;position: relative;top: 2px;}
	#zfyLogoBox .logo-name {display: inline-block;font-size: 16px;color: #FFFFFF;white-space:nowrap;}

	/* //滚动条凹槽的颜色，还可以设置边框属性 */
	::-webkit-scrollbar-track-piece {background-color: #FFFFFF;}

	/* //滚动条的宽度 */
	::-webkit-scrollbar {width: 4px;height: 10px;}
	#aside_box::-webkit-scrollbar {width: 0;}
	.el-table__fixed-right::before, .el-table__fixed::before{background: none;}

	/* //滚动条的设置 */
	::-webkit-scrollbar-thumb {background-color: #666;background-clip: padding-box;min-height: 28px;border-radius: 2px;}
	::-webkit-input-placeholder {font-size: 12px;}
	::-moz-placeholder {font-size: 12px;}
	:-ms-input-placeholder {/* IE 10+ */font-size: 12px;}
	:-moz-placeholder {/* Firefox 18- */font-size: 12px;}
	
	/* 步骤条 */
	.articleSteps .el-step__head.is-finish{color: var(--zfy-blue) !important;border-color: var(--zfy-blue) !important;}
	.articleSteps .el-step__title.is-finish{color: var(--zfy-blue) !important;}
	.articleSteps .el-step__description.is-finish{color: var(--zfy-blue) !important;}
	.articleSteps .el-step__icon.is-text{border-color: none !important; }
	
	/* 每页的导航提示 */
	.header_ContentBox .Icon{color: #2c4198 !important;font-size: 20px;}	
	.header_ContentBox .header_text{color: #616870 !important; font-size: 12px !important;}
	
	/* 弹框下换线 */
	.el-dialog__header { border-bottom: 1px solid #e8e8e8;}
	.header_box .el-header {width: 100%;background-color: var(--zfy-blue);color: #ffffff;height: 50px;line-height: 50px;position: fixed;top: 0;left: 0;z-index: 98;font-size: 14px;padding-left: 270px;transition: all 0.35s;-moz-transition: all 0.35s;-webkit-transition: all 0.35s;-o-transition: all 0.35s;}
	.el-menu-item.is-active {background-color: #e1e0e0;color: var(--zfy-blue) !important;}
	.menuListBox .el-menu-item.is-active{background: none;}
	.menuListBox .el-menu-item.is-active span{font-weight: 700 !important;}
	.menuListBox .el-menu-item:focus, .menuListBox .el-menu-item:hover {background: none;}
	.el-menu-item:focus, .el-menu-item:hover {background-color: #f5f5f5;}
	.el-submenu__title:hover {background-color: #f5f5f5;}
	.el-submenu__title {color: #555555;width: 100%;border-radius: 6px;height: 45px;line-height: 45px;font-weight: bold;}
	.el-menu-item {color: #616870;height: 45px;line-height: 45px;font-weight: bold;}
	.el-menu {border: none;background-color: #FFFFFF;color: #666666;}
	
	/* 项目信息  form */
	.el-input__inner{height: 30px;line-height: 30px;font-size: 12px;}
	.el-date-editor .el-range__close-icon{ line-height:24px; }
	.el-form-item{margin-bottom: 18px;}
	.el-form-item__label{line-height: 30px;font-size: 12px;color: #797979;}
	.el-form-item__content{line-height: 30px;}
	.el-input__icon{line-height: 30px;}
	.el-date-editor .el-range__icon{line-height: 24px;}
	.el-date-editor .el-range-separator{line-height: 22px; color: #787878;}
	.projectNew .el-textarea__inner{font-size: 12px;}
	.header_search .el-input__inner {height: 28px !important;}
	.el-upload-dragger .el-upload__text{font-size: 12px;}
	.el-date-editor .el-range-input, .el-date-editor .el-range-separator{font-size: 12px;}
	
	/* 资金明细 */
	.FundInfo .el-input__inner{height: 30px;line-height: 30px;}	
	.aside_box {color: #60686f;position: fixed;height: 100%;left: 0;top: 0px;z-index: 100;overflow-x: hidden;transition: all 0.35s;-moz-transition: all 0.35s;-webkit-transition: all 0.35s;-o-transition: all 0.35s;box-shadow: 2px 5px 10px rgba(0, 0, 0, 0.1);-moz-box-shadow: 2px 5px 10px rgba(0, 0, 0, 0.1);-webkit-box-shadow: 2px 5px 10px rgba(0, 0, 0, 0.1);}
	.el-main {padding: 0;overflow: hidden;}
	.header_box .el-main {padding-top: 50px;}
	.upfoldBox,
	.foldBox {line-height: 30px;height: 80px;text-align: center;}
	.el-submenu .el-menu-item {height: 40px !important;line-height: 40px !important;padding: 0 !important;min-width: 130px !important;border-radius: 23px !important;position: relative;}
	.el-submenu__title .el-menu-item {background-color: var(--theme-logo);}
	.movejiantou {position: absolute;left: 30px;top: 2px;transition: all 0.35s;font-size: 8px !important;}
	.lowerMenu {display: inline-block;padding-left: 52px !important;font-size: 13px !important;width: 130px;font-weight: 300 !important;}
	
	/* 提示框 */
	.el-dialog__header {padding: 20px 20px 10px;border-bottom: 1px solid #e8e8e8;}
	.el-dialog__title{font-size: 14px;font-weight: 700;}

	/* ----------- */
	.el-header {padding: 0;}
	.el-menu-vertical-demo:not(.el-menu--collapse) {width: 200px;background:#FFFFFF;}
	.sidebar-brand {width: 100%;height: 50px; background-color: var(--zfy-red);}
	.exitBox {text-align: right;}
	.exitBox-title{height:26px;font-size:12px;color: #333;margin-bottom: 5px;}
	.thinNav {padding-left: 65px;transition: all 0.35s;-moz-transition: all 0.35s;-webkit-transition: all 0.35s;-o-transition: all 0.35s;}
	.fatNav {padding-left: 200px;transition: all 0.35s;-moz-transition: all 0.35s;-webkit-transition: all 0.35s;-o-transition: all 0.35s;}
	.header_search {margin-left: 10px;width: 245px;display: inline-block;position: relative;}
	#search_but {position: absolute;right: 10px;top: 2px;color: #000000;cursor: pointer;}
	.undeOne li:hover {background: #f8f9fa;}
	.undeOne li {line-height: 30px;margin: 5px 0;cursor: pointer;border-radius: 5px;font-size: 13px;color: var(--theme-purple);padding-left: 10px;}
	.exitAccountBox{color: #D0121B !important;margin-top: 10px !important;} 
	.navSubtitle {padding: 10px 15px;color: #868e96;font-size: 10px;text-transform: uppercase;letter-spacing: 0.35px;font-weight: 600;}
	.Nav_item1 {margin-left: 6px;width: 92%;border-radius: 23px;}
	.Nav_item0 {width: 56px;border-radius: 6px;margin: 10px 0 10px 4px;}
	.el-menu-item span,
	.el-submenu__title span {padding-left: 8px;font-weight: 700;}
	.switchBtnPc {display: inline-block;width: 40px;text-align: center;}
	.switchBtnWebApp{display: none;width: 40px;text-align: center;}
	.companyName {display: inline-block;font-size: 14px;font-weight: 500;margin-right: 20px;}
	.companyName a{color: #FFFFFF;}
	.companyName:hover {text-decoration: underline;}
	.userPhoto {width: 35px;border-radius: 5px;}
	.headerLeftArea {height: 50px;line-height: 50px;}
	.main-footer{padding:0 20px;background-color: #FFFFFF;height: 50px;line-height: 50px;border-top: 1px solid #e3eaef;margin-top: 20px;}
	.main-footer .footerHref{color: #6777ef;}
	.main-footer .footerHref:hover{text-decoration: underline;}
	.content_Box{background-color: #FFFFFF;border-radius: 5px;margin-top: 10px;padding-top: 10px;padding-bottom: 10px;}
	.el-button--primary{background-color: var(--theme-purple);border-color: var(--theme-purple);}
	.el-button--primary:focus, .el-button--primary:hover{background: var(--theme-purple);border-color: var(--theme-purple);}
	.el-table td, .el-table th{padding:4px 0;}
	/* 首页 */
	.Module3-box-twoBox .el-table th{background :none;height: 1px;font-size: 1px;padding: 0;}
	
	/* 新建订单 */
	.el-table{font-size: 13px;}	
	.el-upload-dragger .el-upload__text em{color:var(--theme-btn);}	
	.flex-item-up{width: 100%;}
	.stepTwo .el-upload-dragger{width: 100%;padding-right: 30px;height: 200px;border: 1px dashed var(--theme-btn);text-align: left;}
	.stepTwo .el-upload-dragger .el-upload__text{text-align: left;}
	.regPagination{height: 30px;margin-top: 30px;margin-bottom: 30px;text-align: right;}
	.regPagination .el-pagination{float: right;}
	.stepThree input[type="text"]{-web-kit-appearance:none; -moz-appearance: none;outline:0;height:24px;box-sizing: border-box; border-radius:4px; border:1px solid #c8cccf;color:#6a6f77;text-decoration:none;font-size: 12px;};
	.stepOne .el-form-item{margin-bottom: 20px;}
	
	/* 企业信息管理 */
	.el-collapse{border-top: none;}
	.el-collapse-item__wrap{border-bottom:none;}
	.el-collapse-item__header{border-bottom:1px solid #f5f5f5;height: 30px;}
	.el-collapse-item__header.is-active{border-bottom:1px solid #E8E8E8;}
	.textareaBox .el-textarea textarea{width: 300px;}
	.companyInfo input{width: 300px;}
	.operateBtn {float: right;}
	.el-pagination.is-background .el-pager li:not(.disabled).active{background-color: var(--theme-red);color: #FFFFFF !important;}
	.el-pagination.is-background .el-pager li:not(.disabled):hover{color:var(--theme-red);}
	.el-pager li.active{background-color: var(--theme-red);color: #FFFFFF !important;}
	.el-pager li{margin: 0 5px;padding: 0;min-width: 30px;border-radius: 2px;}
	.el-radio-button__orig-radio:checked+.el-radio-button__inner {color: #FFF; background-color: #2C4198; border-color: #2C4198;-webkit-box-shadow: -1px 0 0 0 #2C4198;box-shadow: -1px 0 0 0 #2C4198;}
	.el-checkbox__input.is-checked+.el-checkbox__label{color: #2C4198;}
	.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: #2C4198;border-color: #2C4198;}
	.el-radio__input.is-checked .el-radio__inner{border-color: var(--theme-purple);background: var(--theme-purple);}
	.el-radio__input.is-checked+.el-radio__label{color:var(--theme-purple);}
	
	/* 企业操作记录 */
	.companyOperatingRecordBox .el-table td{padding: 4px 0;font-size: 12px;color: #333333;}
	.orderList .el-table th{padding: 3px 0;}
	.el-table th{	font-size: 12px; padding: 8px 0;background-color: #ebeef5;font-weight: 700;color: #333333;}
	.el-table{font-size: 12px;}
	.InfoFont {/* 详情字体 */font-size: 12px;}
	.el-table--striped .el-table__body tr.el-table__row--striped td{background: #F7F7F7;}
	.userPwdBox input{width: 300px;}
	
	/* 按钮 */
	.btnOK, .addOK, .forbidBtn{display: inline-block;height: 30px;line-height: 30px;padding: 0 20px;border-radius: 18px;transition: all 0.3s;cursor: pointer;font-size: 14px;color: #FFFFFF;}
	.btnOK{background-color: var(--theme-btn);box-shadow: 1px 2px 5px var(--theme-purple2);-moz-box-shadow: 1px 2px 5px var(--theme-purple2);-webkit-box-shadow: 1px 2px 5px var(--theme-purple2);opacity: 0.8;}
	.btnOK:hover {opacity: 1;}
	.addOK{background-color: #0acf97;box-shadow: 1px 2px 5px rgba(10,207,151,0.3);-moz-box-shadow: 1px 2px 5px rgba(10,207,151,0.3);-webkit-box-shadow: 1px 2px 5px rgba(10,207,151,0.3);}
	.addOK:hover {background-color: rgba(10,207,87,1);}
	.resetBtn{display: inline-block;height: 28px;line-height: 28px;padding: 0 20px;border:1px solid  var(--theme-btn);font-size: 14px;background-color: #FFFFFF;color:  var(--theme-btn);cursor: pointer;opacity: 0.8;border-radius: 18px;transition: all 0.3s;}
	.resetBtn:hover {background: #e6eaff;color: #3a54e2;}
	.resetBtn:active{background: #3a54e2;color: #FFFFFF;}
	.greenBtn {display: inline-block;height: 28px;line-height: 28px;font-size: 14px;border: 1px solid var(--theme-cyan);border-radius: 16px;padding: 0 20px;color: green;box-shadow: 0 1px 4px var(--theme-cyan);-moz-box-shadow: 0 1px 4px var(--theme-cyan);-webkit-box-shadow: 0 1px 4px var(--theme-cyan);cursor: pointer;}
	.greenBtn:hover {background-color: #ddf7f0;}
	.greenBtn i {font-size: 18px;color: green;}
	.blueBtn {display: inline-block;height: 28px;line-height: 28px;border: 1px solid var(--theme-btn);border-radius: 16px;padding: 0 20px;color: var(--theme-btn);cursor: pointer;font-size: 14px;box-shadow: 0 1px 4px var(--theme-btn);-moz-box-shadow: 0 1px 4px var(--theme-btn);-webkit-box-shadow: 0 1px 4px var(--theme-btn);}
	.blueBtn:hover {background-color: #f3f5fe;}
	.blueBtn i {font-size: 18px;color: #3a54e2;}
	.miniBlueBtn{display: inline-block;height: 22px;line-height: 20px;background-color: var(--theme-btn);border: 1px solid var(--theme-btn);border-radius: 11px;padding: 0 14px;color: #FFFFFF;cursor: pointer;opacity: 0.8;font-size: 13px;}
	.miniBlueBtn:hover{opacity: 1;}
	.forbidBtn{border:1px solid #C1C4CB; color: #C1C4CB; cursor:not-allowed;}  /*禁止点击的按钮*/
	
	.cancelBlueBtn{display: inline-block;height: 22px;line-height: 20px;border: 1px solid var(--theme-btn);border-radius: 11px;padding: 0 14px;color: var(--theme-btn);cursor: pointer;font-size: 13px;background-color: #FFFFFF;}
	.cancelBlueBtn:hover{background-color: #edeef8;}
	.OrderAbnormal_headerBox .el-input-group--append .el-input__inner,
	.el-input-group__prepend{border-top-left-radius : 20px;border-bottom-left-radius : 20px;}
	.OrderAbnormal_headerBox .el-input-group__append{background: #3a54e2;border: 1px solid #3a54e2;color:#FFFFFF;border-top-right-radius : 20px;border-bottom-right-radius : 20px;transition: all 0.3s;opacity: 0.9;}
	.OrderAbnormal_headerBox .el-input-group__append:hover{opacity: 1;}
	
	/* 发票 */
	.InvoiceDetails .row_box .el-select{width:100%;}
	
	/* 项目详情 */
	.ProjectNewDetail .el-textarea__inner,.orderDetails .el-textarea__inner{min-width: 600px;border: 0;resize: none;padding: 5px 10px;background: #f7f7f7;  /*textarea背景*/}
	.companyInfo .row-info .title-key{width: 90px;}
	.companyInfo .el-input__inner,.companyInfo .el-input__icon{height: 30px;line-height: 30px;}
	.row-info .title-key{width: 82px;text-align: right;font-size: 12px;color: #888888;line-height: 34px;}
	.row-info .list-cont{padding-left: 10px;font-size: 14px;color: #353c48;line-height: 34px;}
	
	/* 项目状态文字颜色 */
	.xm-state-1{color: #0000FF;}
	.xm-state-2{color: #8400FF;}
	.xm-state-3{color: #F5365C;	}
	.xm-state-4{color: #D0121B;}
	.xm-state-5{color: #0ACF97;}
	.xm-state-6{color: #8400FF;}
	.xm-state-7{color: #0ACF97;}
	.xm-state-8{color: #C1C4CB}
	.xm-state-9{color: #8400FF;}
	.xm-state-10{color: #F59A23;}
	
	/* 订单状态文字颜色 */
	.dd-state-0{color: var(--theme-red)!important}	
	.dd-state-1{color: var(--theme-green)!important}
	.dd-state-2{color: var(--theme-orange)!important}
	.dd-state-3{color: var(--theme-red2)!important}
	.dd-state-4{color: var(--theme-purple)!important}
	.dd-state-5{color: var(--theme-logo)!important}
	.dd-state-8{color: var(--theme-cyan2)!important}
	.dd-state-9{color: var(--theme-white)!important}
	.dd-state-10{color: #C1C4CB}
	
	/* 列表操作区域文字颜色 */
	.cz-font{font-weight: 700;padding: 0 1px;}
	.cz-hd{ color: var(--theme-purple3)!important;  } /*回单  默认*/
	.cz-js{color: var(--theme-purple)!important; } /*结算单 详情*/
	.cz-zf{	color: var(--theme-green)!important; }  /*支付*/
	.cz-zuofei{color: var(--theme-red2)!important;}   /*作废*/
	.cz-sh{color: var(--theme-green)!important; }  /*提交审核*/
	.cz-yhk{color: var(--theme-yellow)!important; } /*银行卡*/
	.cz-qy{color: #727CF5 !important;}  /*签约检查*/
	.cz-dxtz{color: #FB6340 !important;}  /*短信通知*/
	.cz-delete{color: var(--theme-red)!important;}   /*删除*/
	.cz-line{ color:#ccc;cursor:default } /*操作栏中间隔离线*/
	
	/* 表格搜索 */
	.s_companyName .el-input__inner {height: 28px;   border: 0;outline: none; background-color: rgba(0, 0, 0, 0); }
	.s_type .el-input__inner { height: 28px;  border: 0;outline: none;background-color: rgba(0, 0, 0, 0);}
	.search_box{width: 600px;height:28px; border:1px solid #CCCCCC;border-radius:15px;position: relative;}
	.search_box .s_companyName,
	.search_box .s_type,
	.search_box .s_timer{height: 28px;border-right: 1px solid #e8e8e8;}
	.search_box .s_companyName{width: 180px;}
	.search_box .s_type{width: 120px;}
	.search_box .s_timer{width: 230px;}
	.search_box .el-input__icon{line-height: 28px;}
	.search_box .s_submit{position: absolute;right: -1px;top: -1px;text-align: center;height: 30px;line-height: 30px;width: 68px;color: #FFFFFF;background-color: #3a54e2;border-top-right-radius: 19px;border-bottom-right-radius: 19px;letter-spacing: 3px;opacity: 0.8;transition: all 0.4s; font-size: 13px;}
	.search_box .s_submit:hover{opacity: 1;}
	.search_box .el-date-editor .el-range__icon{display: none;}
	.search_box .el-range-editor.el-input__inner{ border: 0;outline: none;background: none;width: 230px;height: 28px;padding: 0 10px; }
	.search_box .el-date-editor .el-range-separator{line-height: 28px;}
	.search_box .el-date-editor .el-range-input, .el-date-editor .el-range-separator{font-size: 12px; background: none;}
	/* 下拉框字体大小 */
	.el-select-dropdown__item{font-size: 12px;}
	
	/* 文本颜色 */
	.text-color-blue{color: var(--theme-purple)}
	.text-color-red{color: var(--theme-red)}
	.text-color-green{color: var(--theme-green)}
	.text-color-yellow{ color: #F59A23;}
	.text-color-default{ color: #797979;}
	
	/* icon */
	.icon-wjx{font-size: 10px;color: var(--theme-red);}
	.zb-asterisk {font-size: 10px;color: var(--theme-red);}
	
	/* 百度地图 */
	.anchorBL{display: none;} /*去除地图百度logo*/
	
	@media (max-width:767.78px) {
		.content_Box{padding: 0;}
		.header_search {display: none;}
		.companyName {display: none;}
		.aside_box {position: absolute;left: -200px;}
		.fatNav {padding-left: 0;}
		.header_box .el-header {padding-left: 10px;}
		/* 上传 */
		.flex-item-up{width: 300px !important;}
		.el-upload-dragger{width: 300px !important;}	
		.BatchUploadBtn{width: 300px !important;}
		.el-table{ /*表格字体大小*/font-size: 10px;}
		.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{min-width: 20px !important;}
		/* 企业信息资料 */
		.textareaBox .el-textarea textarea{width: 200px !important;}
		.contentInfo input{width: 200px !important;}
		/* 企业操作记录 */
		.userPwdBox input{width: 200px !important;}
		
	}

	@media (max-width:991.78px) {
		.switchBtnPc {display: none !important;}
		.switchBtnWebApp {display: inline-block !important;}
		.aside_box {position: absolute;left: -200px;}
		.fatNav {padding-left: 0;}
		.header_box .el-header {padding-left: 10px;}
	}
	@media (min-width:992.78px) {
		.aside_box {position: fixed !important;height: 100% !important;left: 0 !important;top: 0 !important;}
		.header_box .el-header {padding-left: 220px;}
	}
</style>



// WEBPACK FOOTER //
// src/App.vue